/* Smooth in-page scrolling for links marked `data-anchor-scroll`.

   Why a script rather than `scroll-behavior: smooth`: that property only works
   on the scrolling element itself, which is <html>. Setting it there would
   change every anchor jump on the store — skip links, back-to-top, the theme's
   own in-page navigation — as a side effect of one button wanting to glide.
   Marking the individual links keeps the change where it was asked for.

   The link still carries a real href, so it works with this file blocked, on a
   browser that does not run it, and as a right-click "open in new tab". All the
   script does is intercept a plain left click and take the scroll itself.

   Wrapped in an IIFE: a top-level `const` in a classic script is a lexical
   binding, and a second copy of this file on the page would be a redeclaration
   SyntaxError rather than a harmless no-op. */
(function () {
  var REDUCED = '(prefers-reduced-motion: reduce)';

  document.addEventListener('click', function (event) {
    /* Modified clicks belong to the browser: ctrl/cmd opens a new tab, shift a
       new window, alt downloads. Intercepting those would break all three. */
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest('a[data-anchor-scroll]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;

    /* CSS.escape guards an id that happens to contain a character the selector
       parser reads as syntax. Older browsers without it fall back to
       getElementById, which takes the raw string and needs no escaping. */
    var id = href.slice(1);
    var target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();

    var smooth = !window.matchMedia || !window.matchMedia(REDUCED).matches;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });

    /* The address bar is updated to match, so the position is shareable and the
       back button returns where the visitor came from — which a bare
       scrollIntoView would not do. replaceState is deliberate over pushState:
       one button press should not cost two presses of Back to undo. */
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', href);
    }

    /* Focus follows the scroll, or the keyboard is left behind at the button
       while the eye is at the target. tabindex is set only if the element
       cannot already hold focus, and removed again on blur so it does not
       become a permanent tab stop. */
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
      target.addEventListener(
        'blur',
        function () {
          target.removeAttribute('tabindex');
        },
        { once: true }
      );
    }
    target.focus({ preventScroll: true });
  });
})();
